import { upload } from '@/components/FileUpload/file-upload.service_import'
const STATUS_INITIAL = 0

const STATUS_SAVING = 1

const STATUS_SUCCESS = 2

const STATUS_FAILED = 3
export const Uploader = {
  data () {
    return {
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos'
    }
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  methods: {
    clickInputMain () {
      this.$refs.fileInput1.click()
    },
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
      this.loading = false
      this.status = 0
    },
    save (formData, position) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING
      this.loading = true
      upload(formData)
        .then(x => {
          this.picture = x
          this.loading = false
          this.status = 1
          this.currentStatus = STATUS_SUCCESS
        })
        .catch(err => {
          this.loading = false
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    filesChange (fieldName, fileList, position) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name)
      })

      // save it
      this.save(formData, position)
    }
  },
  mounted () {
    this.reset()
  }
}



// WEBPACK FOOTER //
// ./src/components/Mixins/fileUploader.import.js